import { CostCenterResponse } from "../../models/cost-center/cost-center-response.model";
import { DepartmentResponse } from "../../models/department/department-response.model";
import { UnitResponse } from "../../models/unit/unit-response.model";
import { COST_CENTER_LIST, COST_CENTER_LIST_ERROR, COST_CENTER_LIST_SUCCESS, DEPARTMENT_LIST, DEPARTMENT_LIST_ERROR, DEPARTMENT_LIST_SUCCESS, UNIT_LIST, UNIT_LIST_ERROR, UNIT_LIST_SUCCESS } from "../contants";

export const getCostCenters = (assignorGuid: string) => ({
    type: COST_CENTER_LIST,
    payload: { assignorGuid },
});
  
export const getCostCentersSuccess = (response: CostCenterResponse[]) => ({
    type: COST_CENTER_LIST_SUCCESS,
    payload: response,
});
  
export const getCostCentersError = (message: any) => ({
    type: COST_CENTER_LIST_ERROR,
    payload: { message },
});

export const getUnits = (assignorGuid: string) => ({
    type: UNIT_LIST,
    payload: { assignorGuid },
});
  
export const getUnitsSuccess = (response: UnitResponse[]) => ({
    type: UNIT_LIST_SUCCESS,
    payload: response,
});
  
export const getUnitsError = (message: any) => ({
    type: UNIT_LIST_ERROR,
    payload: { message },
});

export const getDepartments = (assignorGuid: string) => ({
    type: DEPARTMENT_LIST,
    payload: { assignorGuid },
});
  
export const getDepartmentsSuccess = (response: DepartmentResponse[]) => ({
    type: DEPARTMENT_LIST_SUCCESS,
    payload: response,
});
  
export const getDepartmentsError = (message: any) => ({
    type: DEPARTMENT_LIST_ERROR,
    payload: { message },
});